import { ExternalComm, ExternalCommuicationParentMessage, Targets, MessageCallback } from "./ExternalComm";

/**
 * ...
 * @author Ric Gray
 */
export class FrameExternalComm implements ExternalComm
{
	private cmdMap:Map<string, MessageCallback> = new Map();
	private myWindow:any;

	public constructor() 
	{	
		/** @fixme Yikes. Not sure what's really going on here. **/
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const that: any = this;

		this.myWindow = window;

		this.myWindow.onmessage = function (msg:any)
		{
			if (that.onMessage !== undefined)
			{
				that.onMessage(msg.data);
			}
			
			if (that.cmdMap.has(msg.data.command))
			{
				const command = that.cmdMap.get(msg.data.command);
				if (command !== undefined) {
					command(msg.data.args);
				}
			}
			
		}
		
	}
	
	setOnMessageCallback()
	{
		return;
	}
	
	setMessageCallback(message:string, callback:MessageCallback):void
	{
		if (callback != null)
			this.cmdMap.set(message, callback);
		else
			this.cmdMap.delete(message);
	}
	
	sendMsgToParent(msg:ExternalCommuicationParentMessage, target:Targets=Targets.ALL_TARGETS):void
	{
		this.myWindow.parent.postMessage(msg, target);
	}
}